import StarHalfSvg from '@assets/images/svg/star-half.svg';
import React from 'react';
import { View } from 'react-native';

export interface StarHalfIconProps {
    size?: number;
    color?: string;
}

export const StarHalfIcon = React.memo<StarHalfIconProps>(function StarHalfIcon({
    size = 24,
    color = '#333333',
}) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <StarHalfSvg width={size} height={size} color={color} />
        </View>
    );
});

export default StarHalfIcon;


